import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function SearchBox({ showBarcode, searchResult, loading, placeholder, width, value }) {
  const { t, i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const widthClass = width ? `w-[${width}]` : "w-80";
  const currentValue = value !== undefined ? value : searchTerm;

  return (
    <div className="relative flex items-center">
      <div
        className={`absolute inset-y-0 ${
          i18n.language === "ar" ? "right-0 pr-4" : "left-0 p-4"
        } flex items-center pointer-events-none`}
      >
        <svg
          className="w-4 h-4 text-gray-500"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
      </div>

      <input
        type="text"
        id="default-search"
        className={`block h-10 ${widthClass} text-sm text-gray-950 font-normal border ${
          i18n.language === "ar"
            ? "ps-10 pe-10 text-right"
            : "ps-10 pe-10 text-left"
        } rounded-md border-[#CCCCCC]`}
        style={{ outline: "none" }}
        placeholder={t(placeholder)}
        value={currentValue}
        onChange={(event) => {
          setSearchTerm(event.target.value);
          searchResult(event.target.value);
        }}
        required
      />

      <div
        className={`absolute top-1/2 -translate-y-1/2 ${
          i18n.language === "ar" ? "left-3" : "right-3"
        } flex items-center`}
      >
        {loading ? (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-500" />
        ) : currentValue ? (
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 text-lg leading-none"
            onClick={() => {
              setSearchTerm("");
              searchResult("");
            }}
          >
            &times;
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default SearchBox;